import { matchPath } from 'react-router-dom';
import { PUBLIC_URL } from '../../config';
import { COMPETITION_DETAILS_PATH } from '../constants';
import { getLanguageCode } from './index';

// Intl does not export this type
type NumberFormatOptions = Parameters<typeof Number.prototype.toLocaleString>[1];

interface GetFormatOptionsArgs {
  numFractionDigits: number;
  removeTrailingZeros?: boolean;
}

const getFormatOptions = ({ numFractionDigits, removeTrailingZeros }: GetFormatOptionsArgs): NumberFormatOptions => ({
  minimumFractionDigits: removeTrailingZeros ? 0 : numFractionDigits,
  maximumFractionDigits: numFractionDigits,
});

export const twoDecimalCaseOption = getFormatOptions({ numFractionDigits: 2 });
const zeroDecimalCaseOption = getFormatOptions({ numFractionDigits: 0 });
const threeDecimalCaseOption = getFormatOptions({ numFractionDigits: 3 });

export const language = getLanguageCode();

export type FormatNumberValueType = 'amount' | 'integer' | 'decimal';

const COMPETITIONS_DISPLAY_THREE_DECIMAL_DIGITS = ['ACE2023', 'SAC2024M1', 'SAC2024M2', 'SAC2024M3', 'IQC2024S1', 'IQC2024S2', 'IQC2024S3'];

interface FormatNumberOptions {
  numFractionDigits?: number;
  removeTrailingZeros?: boolean;
}

export const formatNumber = (value: number, type: FormatNumberValueType, options?: FormatNumberOptions) => {
  if (type === 'integer' || type === 'amount') {
    return value.toLocaleString(language, zeroDecimalCaseOption);
  } else {
    const competitionId = getCompetitionId();
    const formatOptions = options?.numFractionDigits
      ? getFormatOptions(options as GetFormatOptionsArgs)
      : competitionId && COMPETITIONS_DISPLAY_THREE_DECIMAL_DIGITS.includes(competitionId)
      ? threeDecimalCaseOption
      : twoDecimalCaseOption;
    return value.toLocaleString(language, formatOptions);
  }
};

// This way of getting competition id is a hack and should not use
// We want to display three decimal digits for ACE and SAC competition, and it would be temporary
// (https://jira.worldquant.com/browse/BRAINTECH-2315)
// (https://jira.worldquant.com/browse/BRAINTECH-2706)
// So it would better to retrieve competition ID this way instead of passing competition through
// multiple function calls. Also, this way is easier to remove.
// TODO: Remove this function and discuss for a long term solution for displaying scores based on competition
const getCompetitionId = (): string | undefined => {
  // Trim base path from the pathname
  const pathname = window.location.pathname.slice(PUBLIC_URL.length);
  const matched = matchPath<{
    id: string;
    filterName?: string;
  }>(pathname, { path: COMPETITION_DETAILS_PATH });
  return matched ? matched.params.id : undefined;
};
